<template>
  <div class="summary-wrapper">
    <div class="summary-spinner-wrap px-3">
      <img class="logo" :src="spinnerImage" alt="Akademia Przyszłości" />
      <div class="summary-spinner"></div>
      <div class="content" v-orphans>
        <p class="text-blue-500 h1 font-weight-bold">
          {{ $t('form.summary.spinner.title') }}
        </p>
        <p class="text-blue-500" v-html="$t('form.summary.spinner.content')" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const spinnerImage = new URL('/src/assets/images/spinner-akademia-przyszlosci.png', import.meta.url)
  .href
</script>

<style lang="scss" scoped>
.summary-wrapper {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #7ce0d3;
  z-index: 9999;
}
</style>
